angular.module('bmsApp.sm.job')
	.controller('SMEditVisitModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  $q,
				  SMJobSvc,
				  ConfigService,
				  $filter,
				  notify,
				  EmployeeSvc,
				  $mdDialog,
				  SMJobSvc,
				  SMScheduleSvc,
				  visitId) {


			function init() {
				$scope.config = ConfigService.config;
				$scope.datePickerConfig = angular.extend(angular.copy($scope.config.datePicker.basic), {
					options: angular.extend(angular.copy($scope.config.datePicker.basic.options), {
						parentEl: '.modal-content'
					})
				});

				$scope.timePickerConfig = angular.extend(angular.copy($scope.config.uiTimepickerOptions), {
						appendTo: '.modal-content'
				});

				SMScheduleSvc.visit.read({id: visitId}).then((response) => {
					self.job = response.data.visit.job;
					self.selectedVisitId = visitId;
					console.log(self.selectedVisitId, self.job);

					// Set the time
					angular.forEach(self.job.visits, function(visit) {
						var visitDate = moment(visit.visit_date, 'YYYY-MM-DD HH:mm:s');
						angular.extend(visit, {
							visit_time: visitDate
						});
					});


					self.selectedVisit = $filter('filter')(self.job.visits, {id: self.selectedVisitId},true);

					self.linkedVisits = $filter('filter')(self.job.visits, {id: self.selectedVisitId}, function (actual, expected) {
						return actual != expected;
					});

					self.mergable = checkMergable();
				});



			}

			function checkMergable() {
				var mergable = false;
				var visitDate = moment(self.selectedVisit[0].visit_date, 'YYYY-MM-DD HH:mm:ss');
				angular.forEach(self.linkedVisits, function(visit) {
					if (visitDate.format('YYYY-MM-DD') == moment(visit.visit_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')) {
						mergable = true;
					}
				});
				return mergable;
			}

			function merge() {
				$modalInstance.close('merge');
			}

			function toggleInactive() {
				self.selectedVisit[0].inactive = !self.selectedVisit[0].inactive;
			}

			function toggleRemove() {
				self.selectedVisit[0].remove = !self.selectedVisit[0].remove;
			}

			// ------------------------------- VisitList Directives Callbacks ----------------------------
			function minutesUpdated(visit) {
				if (visit) {
					var hours = visit.hours || 0;
					var mins = visit.minutes || 0;
					visit.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
				}
			}

			function removeVisitAtIndex(index) {
				self.job.visits.splice(index, 1);
			}
			// END ----------------------------------------------------------------------------------------

			function cancel() {
				$modalInstance.dismiss('cancel');
			}

			function submit() {
				// combine the date/time columns
				angular.forEach(self.job.visits, function(visit) {
					angular.extend(visit, {
						visit_date: moment(visit.visit_date).format('YYYY-MM-DD') + ' ' + visit.visit_time.format('HH:mm')
					});
				});

				// Before submitting need to check that visit for employee does not overlap
				let visit = self.selectedVisit[0];
				let job = self.job;
				let availabilityChecks = [];
				let requiredCheckCount = Math.max(visit.employees.length, 1);
				for(let i = 0; i < requiredCheckCount; i++) {
					let employee = visit.employees[i];
					availabilityChecks.push(SMJobSvc.checkVisitAvailability(visit, employee, job));
				}
				$q.all(availabilityChecks)
					.then(function (responses) {
						let visitAvailable = true;
						angular.forEach(responses, function (response) {
							if (response.data.is_available !== true) {
								visitAvailable = false;
								notify({
									message: 'Cannot save visit: employee is already booked, please check availability schedule',
									classes: 'error',
									duration: '0'
								});
							}
						});
						if (visitAvailable) {
							// Go ahead and save the visit
							SMJobSvc.save(self.job).then(function(response) {
								$modalInstance.close(response);
							}, function (errors) {
								notify({
									message: errors[0],
									classes: 'error',
									duration: '0'
								});
							});
						}
					});
			}

			var self = $scope.SMEditVisitCtrl = {
				loading: true,
				job: {},
				methods: {
					init: init,
					cancel: cancel,
					submit: submit,
					minutesUpdated: minutesUpdated,
					removeVisitAtIndex: removeVisitAtIndex,
					toggleInactive: toggleInactive,
					toggleRemove: toggleRemove,
					merge: merge
				}
			}

		});
